var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-random-text fn-clear"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.randomValue))]),(_vm.statusConfig.showUnit)?_c('span',{staticClass:"unit",style:(_vm.unitStyle)},[_vm._v(" "+_vm._s(_vm.statusConfig.unit)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }